"use client"
import { Search } from "lucide-react"

const SearchBar = ({ onSearch, placeholder = "Search by chapter or concept" }) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    const searchTerm = e.target.search.value
    onSearch(searchTerm)
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-2xl mx-auto">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <Search className="w-5 h-5 text-gray-400" />
        </div>
        <input
          type="search"
          id="search"
          name="search"
          className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
          placeholder={placeholder}
        />
        <button
          type="submit"
          className="absolute right-2.5 bottom-2.5 bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-white transition-colors"
        >
          Search
        </button>
      </div>
    </form>
  )
}

export default SearchBar
